import { createSelector } from '@reduxjs/toolkit';
import { getCurrentNode } from '../breadcrumbs/selectors';
import { UserAccessRight } from '../../../general/model';
import { RootSelector } from '../../models/rootSelector';
import { RemoverShape } from './model';
import { CHNodeIsFolder } from '../../../general/node';
import { getSelectedNodesInAllFolders } from '../fileManager/selectors/selectors';

export const getRemover: RootSelector<RemoverShape> = (state) => state.remover;
export const getBulkJobID: RootSelector<string | null> = createSelector(
  getRemover,
  (x) => x.bulkJobID,
);

export const getEnabled = createSelector(
  [getSelectedNodesInAllFolders, getCurrentNode],
  (selected) => {
    return (
      selected.every((node) => node.perms.includes(UserAccessRight.delete)) && selected.length > 0
    );
  },
);

export const getSelectedCounts = createSelector([getSelectedNodesInAllFolders], (selected) => {
  const folders = selected.filter(CHNodeIsFolder).length;
  return {
    folders,
    files: selected.length - folders,
  };
});
